import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Loader, Card, Grid, GridColumn, GridRow} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {ContentDispatch} from 'framework';
import REST from 'go/requests/rest';

export const DeclarationSummaryModal = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  const cancel = () => {
    setModalOpen(false);
  };

  const handleClick = () => {
    setModalOpen(true);
  };

  return (
    <React.Fragment>
      {_.get(props, 'context.disasterSummary') ? (
        <React.Fragment>
          <Grid padded={'vertically'}>
            <GridRow>
              <GridColumn>
                <Card.Content>
                  Incident type: {props.context.disasterSummary.incidentType}
                </Card.Content>
                <Card.Content>
                  Incident start date: {props.context.disasterSummary.incidentStartDate}
                </Card.Content>
                <Card.Content>
                  Incident end date:{' '}
                  {props.context.disasterSummary.incidentEndDate || 'and continuing'}
                </Card.Content>
                <Card.Content>
                  Declaration title: {props.context.disasterSummary.declarationTitle}
                </Card.Content>
                <Card.Content>
                  Declaration date: {props.context.disasterSummary.declarationDate}
                </Card.Content>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn>
                <a id="ViewDesignatedAreasAndPrograms" href="#" onClick={handleClick}>
                  <strong>View designations and types of assistance</strong>
                </a>
              </GridColumn>
            </GridRow>
            {props.showInstructionText && (
              <GridRow>
                <GridColumn>
                  <strong>
                    Please fill out the necessary fields for your funding opportunity and
                    submit when you are ready. You can fill this form and continue editing
                    anytime. When you are done, please click Submit.
                  </strong>
                </GridColumn>
              </GridRow>
            )}
          </Grid>
        </React.Fragment>
      ) : (
        <Loader active inline="centered" />
      )}
      {modalOpen && (
        <FemaGoModal
          title="Designations and Types of Assistance"
          size="large"
          open={modalOpen}
          confirmButton="hidden"
          cancelAction={cancel}
        >
          <React.Fragment>
            <Grid>
              <GridRow>
                <GridColumn width={3}>
                  <strong>Declaration title</strong>
                  <br />
                  <p>{props.context.disasterSummary.declarationTitle}</p>
                </GridColumn>
                <GridColumn width={3}>
                  <strong>Incident type</strong>
                  <br />
                  <p>{props.context.disasterSummary.incidentType}</p>
                </GridColumn>
                <GridColumn width={3}>
                  <strong>Incident start date</strong>
                  <br />
                  <p>{props.context.disasterSummary.incidentStartDate}</p>
                </GridColumn>
                <GridColumn width={3}>
                  <strong>Incident end date</strong>
                  <br />
                  <p>
                    {props.context.disasterSummary.incidentEndDate || 'and continuing'}
                  </p>
                </GridColumn>
                <GridColumn width={3}>
                  <strong>Declaration date</strong>
                  <br />
                  <p>{props.context.disasterSummary.declarationDate}</p>
                </GridColumn>
              </GridRow>
            </Grid>
            <hr />
            {_.map(props.contents, (conf, index) => {
              let config = {
                ...conf,
              };
              return <ContentDispatch key={conf.id || index} config={config} />;
            })}
          </React.Fragment>
        </FemaGoModal>
      )}
    </React.Fragment>
  );
};

export const mapStateToProps = (state) => ({
  dynamicComponent: state.dynamicComponent,
});

export default connect(mapStateToProps, null)(connectDynamic(DeclarationSummaryModal));
